/** @jsx jsx */
import { Box, Section, SemiTitle } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';

export default function TextBlock({ title, subtitle }) {
  return (
    <Box>
      <Section.Title>{title}</Section.Title>
      <SemiTitle>{subtitle}</SemiTitle>
    </Box>
  );
}

export const fragment = graphql`
  fragment SanityTitleBlockFragment on SanityTitleBlock {
    title
    subtitle
  }
`;
